import React from 'react'
import {lerp, register} from '../utils'
import {getRealDt, getState} from '../game-surface'
import {handle, raise} from '../events'
import {addGameObject} from '../system'
import {fireMeteor} from '../meteor'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import {makeStyles} from '@material-ui/core/styles'
import {playSound, registerSound} from '../sound'
import {sprite} from '../system/sprite'
import {Text} from 'react-konva'
import {useSpring} from 'react-spring'

let master

export function getGameManager() {
    return master
}

const music = registerSound('/music.mp3')
const takeOff = registerSound('/takeoff.mp3')

function Score() {
    let props = useSpring({score: getState().score || 0})
    return <Text text={`${Math.floor(props.score.getValue()) || '0'}`} fill="white" shadowColor={'rgba(0,0,0,0.5)'}
                 shadowOffsetX={12} shadowOffsetY={12} shadowBlur={20} fontSize={120} x={50} y={10}/>
}

const manager = register('manager', {
    initialize() {
        master = this.$
    },
    postInitialize() {
        this.$.setState('ready')
    },
    methods: {
        Start,
        GameOver,
    },
    states: {
        ready: {
            enter() {
                getState().speed = 0
                raise('readyState')
                // setTimeout(() => {
                //     this.$.setState('playing')
                // }, 2000)
            },
            methods: {
                ui(elements) {
                    elements.push(this.Start)
                },
            },
            exit() {
                raise('startGame', getState())
                getState().gameOver = false
                playSound(music, {loop: true})
                playSound(takeOff)
            },
        },
        playing: {
            enter() {
                this.t = 5
                raise('playing')
                getState().speed = 1
            },
            methods: {
                update(dt) {
                    this.t -= dt
                    if (this.t < 0) {
                        fireMeteor()
                        this.t =
                            Math.max(8 - getState().height / 5000, 2) +
                            Math.random() * 5
                        // this.t = 0.5
                    }
                },
            },
        },

        gameOver: {
            enter() {
            },
            methods: {
                update() {
                    let speed = (getState().speed = lerp(
                        getState().speed,
                        0,
                        getRealDt() * 2
                    ))
                    if (speed < 0.03) {
                        this.$.setState('endScreen')
                    }
                    music.volume = speed

                },
            },
        },
        endScreen: {
            enter() {
                music.volume = 0
                getState().speed = 0
            },
            methods: {
                ui(elements) {
                    elements.push(this.GameOver)
                },
            },
        },
    },
})

handle('gameOver', () => {
    setTimeout(() => master.setState('gameOver'), 3200)
})

handle('initializeGame', () => {
    addGameObject({}, {manager, ...sprite.config({Sprite: Score})})
})

const useStyles = makeStyles((theme) => ({
    title: {
        color: '#555',
    },
    outer: {
        display: 'flex',
        width: '100%',
        flexGrow: 1,
    },
    holder: {
        padding: theme.spacing(2),
        borderRadius: theme.spacing(1),
        background: 'rgba(255,255,255,0.8)',
        maxWidth: '40vw',
        margin: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
    },
}))

function Start() {
    const classes = useStyles()
    return (
        <>
            <Box className={classes.outer}>
                <Box flexGrow={1}/>
                <Box flexGrow={1} className={classes.holder}>
                    <Box p={2} width="100%" flexGrow={0}>
                        <h1>ROCKET REPAIR!</h1>
                    </Box>
                    <Box p={2} className={classes.title}>
                        <p>
                            Launch your rocket and perform inflight repairs
                            using your trusty AutoFac! Just draw on your
                            sketchpad to make new parts and drag them to your
                            rocket.
                        </p>
                        <p>Better parts last longer and score more points!</p>
                        <p>Can you make it to outer space...</p>
                    </Box>
                    <Box flexGrow={1}/>
                    <Box p={2}>
                        <Button
                            onClick={play}
                            color="primary"
                            variant="contained"
                        >
                            Click To Play!
                        </Button>
                    </Box>
                    <Box flexGrow={0.1}/>
                </Box>
            </Box>
        </>
    )

    function play() {
        getGameManager().setState('playing')
    }
}

function GameOver() {
    const classes = useStyles()
    return (
        <>
            <Box className={classes.outer}>
                <Box flexGrow={1}/>
                <Box flexGrow={1} className={classes.holder}>
                    <Box p={2} width="100%" flexGrow={0}>
                        <h1>GAME OVER</h1>
                    </Box>
                    <Box p={2} width="100%" flexGrow={0}>
                        <h3>SCORE: {getState().score}</h3>
                    </Box>
                    <Box flexGrow={1}/>
                    <Box p={2}>
                        <Button
                            onClick={restart}
                            color="primary"
                            variant="contained"
                        >
                            Ok
                        </Button>
                    </Box>
                    <Box flexGrow={.1}/>
                </Box>
                <Box flexGrow={1}/>
            </Box>
        </>
    )

    function restart() {
        raise('resetGame')
        getState().height = 0
        getGameManager().setState('ready')
    }
}
